import { ChangeDetectionStrategy, Component, computed, input, output, signal, ViewEncapsulation } from '@angular/core';

import { ButtonThemePalette } from '../../button';
import { ChecklistItemComponent } from '../checklist-item/checklist-item.component';
import { ChecklistItemModel } from '../checklist.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-checklist-footer',
  templateUrl: './checklist-footer.component.html',
  styleUrl: './checklist-footer.component.scss',
  imports: [ChecklistItemComponent],
  // to customize the elements in the checklist-item component
  encapsulation: ViewEncapsulation.None,
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()',
  },
})
export class ChecklistFooterComponent {
  title = input.required<string>();
  subtitle = input<string>();
  primaryBtnLabel = input<string>('');
  secondaryBtnLabel = input<string>('');
  primary = output<void>();
  secondary = output<void>();

  item = computed<ChecklistItemModel>(() => ({
    title: this.title(),
    subtitle: this.subtitle(),
    actions:
      this.primaryBtnLabel() || this.secondaryBtnLabel()
        ? {
            primary: this.primaryBtnLabel()
              ? {
                  text: this.primaryBtnLabel(),
                  action: () => this.primary.emit(),
                }
              : undefined,
            secondary: this.secondaryBtnLabel()
              ? {
                  text: this.secondaryBtnLabel(),
                  action: () => this.secondary.emit(),
                  palette: ButtonThemePalette.transparent,
                }
              : undefined,
          }
        : undefined,
  }));

  expanded = signal(false);

  onMouseEnter(): void {
    this.expanded.set(true);
  }

  onMouseLeave(): void {
    this.expanded.set(false);
  }
}
